import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const Documents = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("https://kasiaweb.ilakshyaerp.in/api/documents")
      .then(res => res.json())
      .then(setData);
  }, []);

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />
      <div className="container">
        <h2 className="gallery-title">DOWNLOADS</h2>

        <div className="documents-table-wrapper">
          <table className="documents-table">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Document Name</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((d, index) => (
                <tr key={d.id}>
                  <td>{index + 1}</td>

                  <td>{d.title}</td>

                  <td>
                    <a
                      href={`https://kasiaweb.ilakshyaerp.in/uploads/documents/${d.file}`}
                      target="_blank"
                      rel="noreferrer"
                      download
                      className="doc-download-btn"
                    >
                      Download
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Documents;